export default __webpack_public_path__ + "static/media/Screenshot_6.43c052c2.png";